import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-667f2ad0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule-place-card" }
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.hour), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
    ]),
    _withDirectives(_createElementVNode("img", {
      class: "card-img-container",
      src: this.image,
      alt: _ctx.title,
      style: _normalizeStyle(_ctx.styles)
    }, null, 12, _hoisted_2), [
      [_vShow, !this.image.includes(undefined)]
    ])
  ]))
}